var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "versions-layouts-wrapper" },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showModal
          ? _c("div", {
              staticClass: "modal-backdrop-custom",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  return _vm.closeModal.apply(null, arguments)
                },
              },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-up" } }, [
        _vm.showModal
          ? _c(
              "div",
              {
                staticClass: "modal-custom",
                attrs: { role: "dialog", "aria-modal": "true" },
              },
              [
                _c("div", { staticClass: "modal-header-custom" }, [
                  _c("h5", { staticClass: "modal-title-custom" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.modalTitle) + "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "modal-close-btn",
                      attrs: { "aria-label": "Close", type: "button" },
                      on: { click: _vm.closeModal },
                    },
                    [_c("i", { staticClass: "bi bi-x-lg" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body-custom" }, [
                  _c("p", { staticClass: "tab-description mb-3" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.modalDescription) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex flex-column" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.name,
                          expression: "name",
                        },
                      ],
                      staticClass: "version-input",
                      attrs: {
                        placeholder: _vm.inputPlaceholder,
                        type: "text",
                      },
                      domProps: { value: _vm.name },
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.handleSave.apply(null, arguments)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.name = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-end w-100 mt-3" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "show-details-btn text-sm font-medium px-4 mr-1",
                          attrs: { type: "button", disabled: _vm.isSaving },
                          on: { click: _vm.closeModal },
                        },
                        [_vm._v("\n            Cancel\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "dbh-btn dbh-btn--primary",
                          attrs: { type: "button", disabled: _vm.isSaving },
                          on: { click: _vm.handleSave },
                        },
                        [
                          _c("i", { staticClass: "bi bi-floppy mr-1" }),
                          _vm._v(
                            _vm._s(_vm.isSaving ? "Saving..." : "Save") +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }